import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/Card';
import { FormattedDate } from 'react-intl';

import ProjectAvatarStack from '../ProjectAvatarStack';
import ProjectActions from '../ProjectActions';

import {
  ProjectCardContainer,
  ProjectCardHeader,
  ProjectCardDate,
  ProjectCardContent,
  ProjectCardTitle,
  ProjectAvatarStackWrapper,
} from './styles';

const ProjectCard = ({ permissionLevel, projectId, name, createdAt, onActionsMenuItemClick }) => (
  <Card>
    <ProjectCardContainer>
      <ProjectCardHeader>
        <ProjectCardDate>
          <FormattedDate
            value={new Date(createdAt)}
            day="2-digit"
            month="short"
            year="numeric"
          />
        </ProjectCardDate>
        <ProjectActions projectId={projectId} permissionLevel={permissionLevel} onActionsMenuItemClick={onActionsMenuItemClick} isGrey />
      </ProjectCardHeader>
      <ProjectCardContent>
        <ProjectCardTitle>
          {name}
        </ProjectCardTitle>
        <ProjectAvatarStackWrapper>
          <ProjectAvatarStack projectId={projectId} hideButton />
        </ProjectAvatarStackWrapper>
      </ProjectCardContent>
    </ProjectCardContainer>
  </Card>
);

ProjectCard.propTypes = {
  permissionLevel: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  name: PropTypes.string,
  createdAt: PropTypes.string,
  onActionsMenuItemClick: PropTypes.func,
};

ProjectCard.defaultProps = {
  handleMenuClick: () => {},
};

export default ProjectCard;
